import styled from 'styled-components';

export const Container = styled.div`
  .banner {
    margin-top: 4rem;
  }

  &.ultrapremio {
    margin-bottom: 4rem;
  }

  @media (max-width: 768px) {
    &.ultrapremio .banner .swiper .swiper-button-prev,
    &.ultrapremio .banner .swiper .swiper-button-next {
      display: none;
    }

    .banner {
      margin-top: 2rem;
    }
  }

  @media (max-width: 580px) {
    .showcase {
      padding: 0;
    }
  }
`;
